export const environment = {
  production: true,
  name: 'dev',
  languages: {
    availables: [
      'en-EN'
    ],
    default: 'en-EN'
  },
  aws: {
    amplify: {
      aws_user_pools_id: 'eu-west-1_QSPyRHDoI',
      aws_user_pools_web_client_id: '4l7r8vff6ll010e8gk9ehg06c',
      API: {
        REST: 'https://carelflex-dev-iconfig-api.arkema.com/dev/'
      }
    },
    oauth: {
      domain: 'carelflex-dev-iconfig.auth.eu-west-1.amazoncognito.com',
      scope: ['aws.cognito.signin.user.admin', 'openid'],
      redirectSignIn: 'https://carelflex-bo-dev.arkemacloud.com/login',
      redirectSignOut: 'https://carelflex-bo-dev.arkemacloud.com/login',
      responseType: 'code'
    }
  }
};
